import {
  getSellerUncollectedOrders,
  getUndispatchedTasks,
  getReturnVisitOrders,
  getReturnVisitClients,
  getTomorrowTasks,
  getGroupPreOrderData,
  getGroupUnReturnVisitOrders,
  getGroupReturnVisitClients
} from '@/api/worktop'

const state = {}

const mutations = {}

const actions = {
  getGroupReturnVisitClients({commit}, params) {
    return new Promise((resolve, reject) => {
      getGroupReturnVisitClients(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getGroupUnReturnVisitOrders({commit}, params) {
    return new Promise((resolve, reject) => {
      getGroupUnReturnVisitOrders(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getGroupPreOrderData({commit}, params) {
    return new Promise((resolve, reject) => {
      getGroupPreOrderData(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getTomorrowTasks({commit}, params) {
    return new Promise((resolve, reject) => {
      getTomorrowTasks(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getReturnVisitClients({commit}, params) {
    return new Promise((resolve, reject) => {
      getReturnVisitClients(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getReturnVisitOrders({commit}, params) {
    return new Promise((resolve, reject) => {
      getReturnVisitOrders(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUndispatchedTasks({commit}, params) {
    return new Promise((resolve, reject) => {
      getUndispatchedTasks(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getSellerUncollectedOrders({commit}, params) {
    return new Promise((resolve, reject) => {
      getSellerUncollectedOrders(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
